import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _Fortnight } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { LiquidateMonthConstantsEditor } from "../../../../Talentohumano/GestionTH/EmployeeIncapacity/IncapacityEditors/LiquidateMonthConstantsEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PayrollMonthsConstantsEditor } from "../../../../Talentohumano/ParametrosTalentoHumano/EmployeeBonus/Editors/PayrollMonthsConstants.editor";



export const EmployeesByCostingCenter = () => {

    const entailment = useDataBean(_Fortnight);
    const single = Singleton.getInstance();
    // const [montedit, setMontedit] = useState<number>(null);
    const [Montedit, setMontedit] = useState<number>(null)
    const [year, setYear] = useState<number>(single.getCurrenYear());
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])

    const getLista = () => {

        entailment.instance.getEmployeesByCostingCenter(year,Montedit).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        entailment.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        entailment.deleteItemVoid(entailment.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(entailment.bean);
        entailment.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Número de Empleados', property: 'Count', visible: true },
      
    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    // const listaBotones = () => {
    //     const botones = [
    //         { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${entailment.bean.Name}`, "view": true }) } },
    //         { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

    //     ]
    //     return (
    //         <ListMenu listaBotones={botones} />
    //     )
    // }


    return (
        <BasicPage titulo="Consolidado de Empleados por Centro de Costo">
            <div className="row">
                  <div className="col-md-4">
                                        <YearSelector value={year} onChange={setYear} />
                                    </div>
                                    <div className="col-md-4">
                                           <PayrollMonthsConstantsEditor label="Mes" idSelector={Montedit} onChange={(e) => { setMontedit(e) }} />
                                    </div>
                                    <div className="col-md-4 mt-4 p-2">
                                           <BasicButton icon="ri-file-search-line" eventClick={getLista} disable={Montedit === null || Montedit === undefined}>Consultar</BasicButton>
                                    </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={entailment.setBean} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                          
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={entailment.bean.Code} onChange={entailment.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={entailment.bean.Name} onChange={entailment.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {entailment.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}